import type { Meeting } from '../../types';
import { dateLocale } from '../../lib/i18n';

/** Son kaç günün toplantıları tarih başlıklarıyla gösterilir (bugün dahil). */
const RECENT_DAYS = 7;

function startOfDay(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

/** Grup başlığı: "18 Eylül Cuma" — yıl yalnızca bu yıl değilse eklenir. */
function formatDayHeading(date: Date): string {
  const sameYear = date.getFullYear() === new Date().getFullYear();
  return date.toLocaleDateString(dateLocale(), {
    day: 'numeric',
    month: 'long',
    weekday: 'long',
    ...(sameYear ? {} : { year: 'numeric' as const }),
  });
}

export interface DayGroup {
  key: string;
  heading: string;
  meetings: Meeting[];
}

/**
 * Toplantıları ikiye ayırır: son bir haftanınkiler gün gün gruplanır (en yeni
 * gün en üstte), daha eskiler "Geçmiş Toplantılar"a düşer.
 */
export function groupMeetings(meetings: Meeting[]): { recent: DayGroup[]; past: Meeting[] } {
  const cutoff = startOfDay(new Date());
  cutoff.setDate(cutoff.getDate() - (RECENT_DAYS - 1));

  const sorted = [...meetings].sort((a, b) => b.recordedAtISO.localeCompare(a.recordedAtISO));
  const recent: DayGroup[] = [];
  const past: Meeting[] = [];

  for (const meeting of sorted) {
    const date = new Date(meeting.recordedAtISO);
    if (Number.isNaN(date.getTime()) || date < cutoff) {
      past.push(meeting);
      continue;
    }
    const key = startOfDay(date).toDateString();
    const group = recent[recent.length - 1];
    if (group && group.key === key) group.meetings.push(meeting);
    else recent.push({ key, heading: formatDayHeading(date), meetings: [meeting] });
  }
  return { recent, past };
}
